import { useQuery } from "@tanstack/react-query";

import { apiClient } from "@/api/client";

import { promotionKeys } from "./query-keys";

export function usePromotion(id: string, enabled = true) {
  return useQuery({
    queryKey: promotionKeys.promotion(id),
    enabled: enabled && id.length > 0,
    queryFn: async () => {
      const { data, error } = await apiClient.GET("/v1/promotions/{id}", {
        params: { path: { id } },
      });
      /* v8 ignore next -- unreachable: client errorMiddleware throws ApiError on !ok */
      if (error) throw error;
      return data;
    },
  });
}
